import { CommonModule, NgFor } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { CanonicalService } from '../../../shared/seo/canonical.service';

@Component({
  selector: 'app-ux-design',
  imports: [NgFor, RouterModule, CommonModule, FormsModule],
  templateUrl: './ux-design.component.html',
  styleUrl: './ux-design.component.scss',
   encapsulation: ViewEncapsulation.None  // ✅ Make sure this line is here
})
export class UxDesignComponent implements OnInit {
  constructor(
    private titleService: Title,
    private metaService: Meta,
    private canonicalService: CanonicalService
  ) {}

  ngOnInit(): void {
    // Set page title
    this.titleService.setTitle('UX Design | Creative UI/UX by MALtech');

    // Set meta description
    this.metaService.updateTag({
      name: 'description',
      content:
        'MALtech provides expert UX design, digital design, and software development services including wireframing, prototyping, accessibility, and visual design to build intuitive digital products.',
    });

    // Optional: Add other meta tags
    this.metaService.updateTag({
      name: 'keywords',
      content: 'UX Design, User Experience, Web Design, UI',
    });
    this.metaService.updateTag({
      name: 'author',
      content: 'Maltech',
    });
    this.canonicalService.setCanonicalURL('service/ux-design/');
  }
  getStart() {
    const plansSection = document.getElementById('get-start');
    if (plansSection) {
      plansSection.scrollIntoView({ behavior: 'smooth' });
    }
  }

  services = [
    {
      title: 'Web & App UI Design',
      description:
        'Clean, responsive, and user-focused interfaces that enhance usability and engagement across devices.',
      icon: 'laptop',
      active: false,
    },
    {
      title: 'UX Research & Strategy',
      description:
        'Using data, insights, and user behavior analysis, we create strategies that improve journeys and enhance satisfaction.',
      icon: 'people',
      active: true,
    },
    {
      title: 'Prototyping & Wireframing',
      description:
        'Interactive wireframes and prototypes provide clarity, validate ideas early, and accelerate development efficiency.',
      icon: 'grid',
      active: false,
    },
    {
      title: 'Usability Testing',
      description:
        'We evaluate designs through real user feedback to ensure accessibility, simplicity, and effectiveness.',
      icon: 'check2-square',
      active: false,
    },
    {
      title: 'Branding & Visual Identity',
      description:
        'From colors to typography, we craft designs that reflect your brand story, values, and goals.',
      icon: 'palette',
      active: false,
    },
    {
      title: 'Motion & Interaction Design',
      description:
        'Subtle animations and smart interactions bring products to life, making them intuitive and engaging.',
      icon: 'play-circle',
      active: false,
    },
  ];
  tools = [
    {
      icon: 'bi-brush', // UI/UX Design
      title: 'UI/UX Design',
      description:
        'Creating user-centered designs that align with business goals and enhance usability.',
    },
    {
      icon: 'bi-diagram-3', // Prototyping
      title: 'Prototyping & Wireframing',
      description:
        'Designing interactive wireframes and clickable prototypes for faster validation.',
    },
    {
      icon: 'bi-palette', // Branding
      title: 'Branding & Visual Identity',
      description:
        'Building consistent brand elements like logos, color palettes, and typography.',
    },
    {
      icon: 'bi-image', // Graphic Design
      title: 'Graphic & Asset Design',
      description:
        'Designing icons, illustrations, banners, and reusable design components.',
    },
    {
      icon: 'bi-check2-circle', // Usability Testing
      title: 'Usability Testing & Feedback',
      description:
        'Testing designs with users to ensure accessibility, ease of use, and better experience.',
    },
    {
      icon: 'bi-people', // Collaboration
      title: 'Collaboration & Handoff',
      description:
        'Sharing assets, design systems, and specifications seamlessly with teams.',
    },
  ];

  platforms = [
    { name: 'Figma', img: 'assets/images/uxdesign/figma.webp' },
    { name: 'Adobe XD', img: 'assets/images/uxdesign/adobe.webp' },
    { name: 'Illustrator', img: 'assets/images/uxdesign/ai.webp' },
    { name: 'Photoshop', img: 'assets/images/uxdesign/ps.webp' },
    { name: 'Canva', img: 'assets/images/uxdesign/canva.webp' },
    { name: 'Sktech', img: 'assets/images/uxdesign/sktech.webp' },
  ];
}
